import React, { useContext, useEffect, useState } from 'react'
import { Form, Switch } from 'antd'
import { ProjectsContext } from 'views/UserManagement/Projects'

const AdminToggle = ({ record }) => {
  const { form, formKeys } = useContext(ProjectsContext)
  const { id, is_project_admin, is_account_admin, in_project } = record
  let isCurrentlyInProject = form.getFieldValue(`${formKeys.PROJECT_USERS_IN_PROJECT}/${id}`)
  let disableToggle = is_account_admin || !in_project || !isCurrentlyInProject
  const [disabled, setDisabled] = useState(disableToggle)
  let formKey = `${formKeys.PROJECT_USERS_IS_ADMIN}/${id}`

  // Dear Developer,
  // I'm sorry but i couldn't find a better way to manage the complicated state of this f*****g component
  // ¯\_(ツ)_/¯
  useEffect(() => {
    let isCurrentlyDisabled = false
    let isAdmin = false
    // manage on/off
    if (is_project_admin || is_account_admin) {
      isAdmin = true
    }
    // manage enabled/disabled
    if (is_account_admin || !in_project) {
      isCurrentlyDisabled = true
    }
    if (!is_account_admin && isCurrentlyInProject) {
      isCurrentlyDisabled = false
    }

    // this is stupid...
    if (!isCurrentlyInProject) {
      isAdmin = false
      isCurrentlyDisabled = true
    }
    form.setFieldsValue({
      [formKey]: isAdmin
    })
    setDisabled(isCurrentlyDisabled)
  }, [in_project, is_project_admin, is_account_admin, isCurrentlyInProject])

  return (
    <Form.Item style={{ margin: 0 }} key={formKey}>
      {form.getFieldDecorator(formKey, {
        preserve: true,
        initialValue: is_project_admin || is_account_admin,
        valuePropName: 'checked'
      })(<Switch size="small" disabled={disabled} />)}
    </Form.Item>
  )
}

export default AdminToggle
